import * as React from 'react';
import Svg, { Circle, Ellipse, G, Mask, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => (
    <Svg width={props.width ?? 24} height={props.height ?? 24} viewBox={'0 0 24 24'} {...props} fill="none">
        <Circle cx={12} cy={12} r={9} stroke={props.fill || designSystem.colors.neutral300} strokeWidth={1.75} />
        <Circle cx={12} cy={10.5} r={3} stroke={props.fill || designSystem.colors.neutral300} strokeWidth={1.75} />
        <Mask id="account-icon" width={20} height={20} x={2} y={2} maskUnits="userSpaceOnUse" maskType={'alpha'}>
            <Circle
                cx={12}
                cy={12}
                r={9}
                fill={designSystem.colors.neutral400}
                stroke={designSystem.colors.neutral400}
                strokeWidth={1.75}
            />
        </Mask>
        <G mask="url(#account-icon)">
            <Ellipse
                cx={12}
                cy={25}
                stroke={props.fill || designSystem.colors.neutral300}
                strokeWidth={1.75}
                rx={10}
                ry={8}
            />
        </G>
    </Svg>
);
export { SvgComponent as UserIcon };
